module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "href": "#/APerfectSecreteBook2"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("“That’s it? That’s my wedding proposal?” Nineteen-year-old Rose Bender stared at her best friend in the waning light of the cool summer evening.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Luke Lantz’s dark blue eyes held steady as always. “"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ya")]), _vm._v(", what more do you expect?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Rose half bounced in the buggy seat, trying not to let Luke’s typical calmness rile her into a temper that would match the unruly black curls tucked beneath her "), _c('em', {
    staticClass: "i"
  }, [_vm._v("kapp")]), _vm._v(". What more did she expect? It was a fair question.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("She’d known Luke for all of her young life, and he was right—a marriage was something that would please both of their families and have the strong foundation of their friendship at its base. It would also unite two lands, the rich soil that ran parallel in property. And, perhaps most importantly, it would bring a woman’s touch to the motherless Lantz household. But it might have helped if Luke could have conjured up a few romantic words to add to the moment. Yet, at twenty-three, he was what he was: Placid. Faithful. Secure. And when Rose was with him, it was rather like skating on a pond that had been deep-frozen for months—no chance for a crack in the ice. Perfectly safe. Not that she should desire anything more.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“I accept,” she said with determination and not a little defiance. She wanted to silence the doubts that echoed inside—that suggested she knew him too well to have a romantic marriage. And the realistic fears that she could never live up to the legacy of domesticity and kindness his mother had left behind just two short years ago. She told herself that it had to be more than enough to fulfill the expectations of Luke’s father and her parents and to find a strong base in a wealth of memories—school days, sledding and ice-skating together, long walks and throwing horse chestnuts into the pond, and serious conversations about life—though not necessarily about love.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('em', {
    staticClass: "i"
  }, [_vm._v("Gut")]), _vm._v(". I thank you, Rose. I believe, with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Derr")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Herr")]), _vm._v("’s blessing, that it will be a successful match.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("She nodded, then slid closer to his lean form, reaching to trail her fingers in the brown hair at the nape of his neck. She felt him tense, but she ignored it.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Luke,” she whispered, “now that we’re engaged, maybe we could kiss a bit more?”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("His strong jaw tightened, and he turned to peck neatly at her lips, moving away before she could even close her eyes. He disentangled her hand from his hair and gave it a cool squeeze, then picked up the reins. “We’d best move on,” he said. “It’s getting late.”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("And")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("th")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("at’s that")]), _vm._v(", she thought ruefully, comforting herself with the knowledge that he would be too dutiful to maintain such distance once the marriage ceremony was over. She stifled a sigh at the unusually irreverent thought and focused on the dim road ahead.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5185f5d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/APerfectSecreteBook7.vue
// module id = 78
// module chunks = 0